// default navicon
export function navicon() {
    document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
        const navigationContainer = document.querySelector('.site-navigation');
        if (navigationContainer.style.maxHeight) {
            // If the content is already expanded, we collapse it
            navigationContainer.style.maxHeight = null;
            navigationContainer.style.opacity = 0;
        } else {
            // If the content is collapsed, we expand it
            navigationContainer.style.maxHeight = 1000 + "px";
            navigationContainer.style.opacity = 1;
        }

        e.preventDefault();
        e.currentTarget.classList.toggle('site-navigation__navicon--active');
        navigationContainer.classList.toggle('site-navigation--active');
        document.body.classList.toggle('site-navigation--open');
    });
}